import React from "react";
import { Text, Flex, TextField } from "../../../resourses/digitallabs/one-x-ui";

const DynamicInputPincode = ({
  field,
  fieldRefs,
  value,
  isMain,
  isUserNRI,
  isUserFN,
  updateValue,
  submitted,
  errors,
  setPincodeLocks,
  setMultiPincodeOptions,
  renderLabelWithPrefix,
  triggerPincodeIfValid,
}) => {
  const disabled = !!field.default_answer;
  const safeValue = typeof value === "string" || typeof value === "number" ? value : "";
  const inputValue = field.default_answer !== undefined && field.default_answer !== null ? field.default_answer : String(safeValue);
  const fieldName = field.name;

  return isUserNRI || isUserFN ? (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <Text style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>{renderLabelWithPrefix(isMain, field.question)}</Text>

      <TextField
        value={inputValue}
        placeholder="Enter Pincode"
        variant="outline"
        size="md"
        disabled={disabled}
        maxLength={13} //  IMPORTANT
        onChange={(e) => {
          if (!disabled) {
            let val = e.target.value ?? "";

            val = val.replace(/[^a-zA-Z0-9 -]/g, "");
            updateValue(fieldName, val);
          }
        }}
      />

      {submitted && errors[fieldName] && <Text style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors[fieldName]}</Text>}
    </Flex>
  ) : (
    <Flex key={fieldName} direction="column" gap="xs" className="dfh-field-wrapper" ref={(el) => (fieldRefs.current[fieldName] = el)}>
      <Text style={{ fontSize: "14px", fontWeight: 500, marginBottom: "4px" }}>{renderLabelWithPrefix(isMain, field.question)}</Text>

      <TextField
        value={inputValue}
        placeholder="Enter Pincode"
        variant="outline"
        size="md"
        maxLength={6}
        disabled={disabled}
        onChange={(e) => {
          if (!disabled) {
            let val = e.target.value ?? "";
            val = val.replace(/[^0-9]/g, "");

            updateValue(fieldName, val);
            const type = fieldName === "pincodeResidence" ? "residence" : "work";

            //  UNLOCK if not 6 digits
            if (val.length !== 6) {
              setPincodeLocks((prev) => {
                if (prev[type] === false) return prev;
                return {
                  ...prev,
                  [type]: false,
                };
              });
            }

            setMultiPincodeOptions((prev) => {
              if (prev[type] === null) return prev;
              return {
                ...prev,
                [type]: null,
              };
            });
            // Fetch pincode options if 6 digits
            // if (val.length === 6) {
            //   triggerPincodeIfValid(val, fieldName, type);
            // }
          }
        }}
      />

      {submitted && errors[fieldName] && <Text style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>{errors[fieldName]}</Text>}
    </Flex>
  );
};

export default DynamicInputPincode;
